import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isMenuLoading: false,
  isMenuLoaded:false,
  menuData:null,
  selectedMenu:null,
  isChildMenuLoading: false,
  selectedChildMenu:null,
  menuLoadingError:'',
  isMenuHasChildrens:false,
  isMenuCollapse:false,
};

const menuSlice = createSlice({
    name: "menus",
    initialState,
    reducers: {
        menuLoadingPending: (state) => {
            state.isMenuLoading = true;
        },
        menuLoadingSuccess: (state, {payload}) => {
            state.isMenuLoading = false;
            state.isMenuLoaded = true;
            state.isChildMenuLoading = false;
            state.menuData = payload;
            state.selectedMenu = null;
            state.selectedChildMenu = null;
            state.menuLoadingError = '';
        },
        menuLoadingFail: (state, { payload }) => {
            state.isMenuLoading = false;
            state.isMenuLoaded = false;
            state.isChildMenuLoading = false;
            state.menuData = null;
            state.selectedMenu = null;
            state.selectedChildMenu = null;
            state.menuLoadingError = payload;
        },
        selectMenu: (state, { payload }) => {
            const selectedMenu = state?.menuData?.modules?.find((menu)=> menu?.name === payload);
            if(selectedMenu){
                state.selectedMenu = selectedMenu;
                state.selectedChildMenu = null;
            }else{
                // Set Default Error Menu
            }
        },
        selectChildMenu:(state, { payload }) => {
            const selectedChildMenu = state.selectedMenu.childrens.find((menu)=> menu.name === payload);
            if(selectedChildMenu){
                state.selectedChildMenu = selectedChildMenu;
            }else{
                // Set Default Error Child Menu
            }
        },
        toggleCollapseMenu:(state) => {
            state.isMenuCollapse = !state.isMenuCollapse;
        },
        resetMenuState: () => initialState,
    },
});
  
  const { reducer, actions } = menuSlice;
  
  export const { menuLoadingPending, menuLoadingSuccess, menuLoadingFail, selectMenu, selectChildMenu, toggleCollapseMenu, resetMenuState } = actions;
  
  export default reducer;